import React, { useEffect, useState } from 'react';
import './finalSection.scss';
import {
	HeaderSocialDiscord, HeaderSocialTelegram,
	HeaderSocialTwitter,
	HeaderSocialYoutube
} from "../../../../components/images/HeaderSocialIcons";

const FinalSection = () => {
	const [width, setWidth] = useState(window.innerWidth);
	const updateDimensions = () => {
		setWidth(window.innerWidth);
	}
	useEffect(() => {
		window.addEventListener("resize", updateDimensions);
		return () => window.removeEventListener("resize", updateDimensions);
	}, []);
	
	return (
		<div className="finalSection">
			<div className="stars"></div>
			<div className="stars2"></div>
			<div className="stars3"></div>
			<div className="finalSection__content">
				<div className="finalSection__content_title">
					<h2>Start your journey in crypto with NFD Platform</h2>
					<span>Connect your web-3 wallet and get the access to all the functions of our platform absolutely free.</span>
				</div>
				
				<div className="finalSection__content_button">
					<button
						className="secondButton"
						onClick={() => window.open('https://app.nfd.gg/ru')}
					>
						<span>Start earning now</span>
					</button>
					
					<div className="finalSection__content_button_growing">
						<p>Join our growing <br/> global <span className="finalSection__content_button_growing_community">community</span></p>
						<img
							src={`${process.env.PUBLIC_URL}/assets/images/nfdPlatform/final/${width > 1023 ? 'DottedArrow' : 'DottedArrowAdaptive'}.svg`}
							alt="Dotted arrow"
						/>
					</div>
				</div>
				
				<div className="finalSection__content_social">
					<button onClick={() => window.open("https://x.com/")}>
						<HeaderSocialTwitter />
					</button>
					<button onClick={() => window.open("https://discord.com/")}>
						<HeaderSocialDiscord />
					</button>
					<button onClick={() => window.open("https://www.youtube.com/")}>
						<HeaderSocialYoutube />
					</button>
					<button onClick={() => window.open("https://web.telegram.org/")}>
						<HeaderSocialTelegram />
					</button>
				</div>
				
				<div className="finalSection__content_background"></div>
			</div>
		</div>
	);
};

export default FinalSection;